document.addEventListener("turbolinks:load", function() {
	var shippingSelect = document.getElementById("order_shipping_option_id");
	var shipDateRow = document.getElementById("ship_date_row");
	var shipDateField = document.getElementById("order_ship_date");

	if (!shippingSelect || !shipDateRow) return;

	function toggleShipDate() {
		var selectedOption = shippingSelect.options[shippingSelect.selectedIndex];
		var isFutureShipDate = selectedOption && selectedOption.text.match(/future ship date/i);

		if (isFutureShipDate) {
			shipDateRow.style.display = "";
		} else {
			shipDateRow.style.display = "none";
			if (shipDateField) shipDateField.value = "";
		}
	}

	shippingSelect.addEventListener("change", toggleShipDate);
	toggleShipDate();
});
